import React, { useState } from "react";
import styles from "./AddDiscount.module.css";
import { useDispatch } from "react-redux";
import { closeModal } from "../../redux/slices/modalSlice";

import HeadingAndData from "../../components/HeadingAndData/HeadingAndData";
import HeadingAndDropDown from "../../components/HeadingAndDropDown/HeadingAndDropDown";
import RadioComponent from "../../components/RadioComponent/RadioComponent";
import SaveAndCancel from "../../components/SaveAndCancel/SaveAndCancel";
import ToClose from "../../components/ToClose/ToClose";
import HeadingAndIcon from "../../components/HeadingAndIcon/HeadingAndIcon";
import { IoDocumentTextOutline } from "react-icons/io5";

const AddDiscount = () => {
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    name: "",
    type: "INR",
    value: "",
    code: "",
    discountType: "",
  });

  const handleChange = (field) => (e) => {
    setFormData((prev) => ({
      ...prev,
      [field]: e.target.value,
    }));
  };

  const handleCancel = () => {
    dispatch(closeModal());
  };

  const handleSave = () => {
    if (!formData.name || !formData.value || !formData.code) {
      alert("Please fill all required fields.");
      return;
    }
    console.log("Discount data submitted:", formData);
    dispatch(closeModal());
  };
  

  return (
    <div className={styles.modal}>
      <div className={styles.header}>
        <HeadingAndIcon
          icon={<IoDocumentTextOutline  />}
          heading="Add discount"
        />
        <ToClose onClose={handleCancel} />
      </div>

      <div className={styles.content}>
        <HeadingAndData
          label="Name"
          name="name"
          placeholder="Enter your name"
          value={formData.name}
          onChange={handleChange("name")}
          required
        />

          <label className={styles.radioLabel}>
            Type<span className={styles.required}> *</span>
          </label>
          <div className={styles.radioOptions}>
            <RadioComponent
              name="type"
              value="INR"
              label="INR"
              checked={formData.type === "INR"}
              onChange={handleChange("type")}
            />
            <RadioComponent
              name="type"
              value="Percentage"
              label="Percentage"
              checked={formData.type === "Percentage"}
              onChange={handleChange("type")}
            />
          </div>
        

        <HeadingAndData
          label={`Discount in ${formData.type}`}
          name="value"
          placeholder="Please enter value"
          value={formData.value}
          onChange={handleChange("value")}
          required
        />

        <HeadingAndData
          label="Item Code"
          name="code"
          placeholder="Please enter item code"
          value={formData.code}
          onChange={handleChange("code")}
          required
        />

        <HeadingAndDropDown
          label="Discount Type"
          name="discountType"
          value={formData.discountType}
          onChange={handleChange("discountType")}
          options={[
            { label: "Standard", value: "Standard" },
            { label: "Seasonal", value: "Seasonal" },
            { label: "Promotional", value: "Promotional" },
          ]}
        />

        <div className={styles.actions}>
          <SaveAndCancel onCancel={handleCancel} onSave={handleSave} />
        </div>
      </div>
    </div>
  );
};

export default AddDiscount;
